import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        console.log('[AuthCallback] Starting session processing');
        
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        console.log('[AuthCallback] Full URL hash:', hash);
        
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        console.log('[AuthCallback] Extracted session_id:', sessionId);

        if (!sessionId) {
          console.error('[AuthCallback] ERROR: No session_id found in URL');
          throw new Error('No session_id found');
        }

        // Exchange session_id for user data
        console.log('[AuthCallback] Calling backend google-session endpoint');
        const response = await fetch(`${BACKEND_URL}/api/auth/google-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        console.log('[AuthCallback] Backend response status:', response.status);
        const data = await response.json();
        console.log('[AuthCallback] Backend response data:', { ...data, token: data.token ? `${data.token.substring(0, 20)}...` : 'missing' });

        if (!response.ok) {
          console.error('[AuthCallback] ERROR: Backend returned error', data);
          throw new Error(data.detail || 'Authentication failed');
        }

        // Store token in localStorage for session persistence
        if (data.token) {
          console.log('[AuthCallback] Storing token in localStorage');
          localStorage.setItem('session_token', data.token);
        } else {
          console.warn('[AuthCallback] WARNING: No token in response');
        }

        toast.success('Successfully logged in!');
        
        // Navigate based on onboarding status using window.location for reliable redirect
        const redirectPath = !data.onboarding_completed ? '/onboarding' : '/dashboard';
        console.log('[AuthCallback] Redirecting to:', redirectPath);
        window.location.href = redirectPath;
      } catch (error) {
        console.error('[AuthCallback] Auth callback error:', error);
        toast.error(error.message || 'Authentication failed');
        window.location.href = '/login';
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen bg-[#1C2127] flex items-center justify-center px-4">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00B4D8] mx-auto"></div>
        <p className="text-lg text-[#ADB5BD]">Completing authentication...</p>
      </div>
    </div>
  );
}
